var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathRoadCycling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cykel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368.5 368.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #1d1d1b;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 184.25,
    cy: 184.25,
    r: 184.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gr\\xF6n_100-450"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.01,45.89c-3.03,5.02-9.55,6.63-14.57,3.61-5.02-3.03-6.63-9.54-3.61-14.56,3.01-5.02,9.54-6.63,14.56-3.62,5.02,3.02,6.64,9.55,3.62,14.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.88,141.41l-7.24.03-3.86,1.55-2.57-1.52-13.05.06c13.97-2.26,24.69-14.37,24.69-28.97,0-16.2-13.18-29.38-29.38-29.38-2.52,0-4.95.35-7.28.95l-6.12-16.82h-.02l-1.29-4.22-13.71-2.52-11.42-17.19-8.22,4.34-24.37,13.09-.66,12.01,16.88,11.01-1.15,7.48c-5.27-5.01-12.34-8.14-20.17-8.14-16.2,0-29.38,13.18-29.38,29.38s12.8,28.96,28.67,29.34l-19.85.09-4.5,1.77-2.89-1.73-3.45.04v5.14s140.37-.13,140.37-.13l-.05-5.67h0ZM125.26,112.57c0-11.42,9.29-20.7,20.7-20.7,7.98,0,14.91,4.55,18.37,11.18l-1.45,9.41,3.78.03v.07c0,11.42-9.29,20.7-20.7,20.7s-20.7-9.29-20.7-20.7h0ZM197.53,141.68l-3.53,1.91-7.88-1.87-12.85.06-5.46,1.48-4.18-1.44-16.83.08c15.81-.45,28.53-13.42,28.53-29.33l9.23-33.12-8.81-9.43,7.32-3.33,3.99,3.33,19,.25,5.61,15.42c-10.34,4.56-17.58,14.88-17.58,26.88,0,14.7,10.86,26.87,24.96,29.01l-21.53.1h0ZM202.77,112.57c0-8.26,4.87-15.38,11.88-18.7l7.07,19.45,4.49-1.63-7.05-19.37c1.39-.29,2.83-.46,4.3-.46,11.42,0,20.7,9.29,20.7,20.7s-9.29,20.7-20.7,20.7-20.7-9.29-20.7-20.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.81 104.71 186.25 89.48 190.41 112.35 183.68 112.42 181.81 104.71"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathRoadCycling);
export default __webpack_public_path__ + "static/media/path-road-cycling.a083c495.svg";
export { ForwardRef as ReactComponent };